const initialState = {
    pageNo:0,
    totalCount:0,
    data:[],
    data2:[],
    isLoading:false,
    searchQuery:'',
    domains:{
      "id": 25,
      "indexId": 25,
      "name": "All",
      "visible": true,
      "answerable": true,
      "value": "All",
      "label": "All"
  },
  words:'2',
  selectedIndex:0,
  selectedDomain:'All',
  reload:'reload'
}

const keyTermPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case 'keyTermDomainUpdate':
    state = { ...state, pageNo:0 };
    state = { ...state, data:[], data2:[] };
    state = { ...state, domains:payload,selectedDomain:payload  };

    return state;
  case 'keyTermSearchQueryUpdate':
    state = { ...state, data:[],data2:[] };
    state = { ...state, pageNo:0 };
    state = { ...state, searchQuery:payload };
    return state;
  case 'keyTermDataUpdate':
    let newData = [];
    if(state.pageNo === 0){
      newData = payload.data;
    }else{
      newData = state.data.concat(payload.data);
    }
    state = {...state, totalCount:payload.count}
    state = {...state, data: newData, data2:payload.data};
    state = {...state, isLoading:false}
    return state;
  case 'keyTermDataIsLoading':
    state = { ...state, isLoading:payload };
    return state;
  case 'keyTermDataPageNoUpdate':
    state = { ...state, pageNo:payload };
    return state;
  case 'keyTermWordsChange':
    state = { ...state, words:payload, pageNo:0 };
    state = { ...state, selectedIndex:payload-1 };
    return state;
  case 'keyTermWordsReload':
    let randomVal = Math.random()*10;
    // state = { ...state, words:1 };
    // state = { ...state, selectedIndex:0 };
    // state = { ...state, searchQuery:'' };
    state = {...state, reload:randomVal.toString()}
      return state;
  default:
    return state
  }
}
export default keyTermPageReducer;
